import React from 'react';
import { Plus, Trash2, Edit2 } from 'lucide-react';
import { useI18n } from '../i18n';
import CategoryIcon from './CategoryIcon';
import { getCategoryColor, getCategoryName } from '../utils';
import { Badge, Button, Card, IconButton, PageHeader } from './ui';

export default function Tarefas({ tarefas, categorias, onNew, onEdit, onDelete }) {
  const { t } = useI18n();
  return (
    <div>
      <PageHeader
        title={t('tasks.title')}
        subtitle={t('tasks.description')}
        actions={<Button onClick={onNew}><Plus size={16} />{t('tasks.newTask')}</Button>}
      />
      <div className="space-y-8">
        {categorias.map(categoria => {
          const tarefasCategoria = tarefas.filter(tf => tf.categoria_id === categoria.id);
          return (
            <section key={categoria.id}>
              <div className="flex items-center gap-2.5 mb-3">
                <span className={`inline-flex items-center justify-center w-7 h-7 rounded-md ${getCategoryColor(categoria.id)}`}>
                  <CategoryIcon iconName={categoria.icone} size={15} />
                </span>
                <h2 className="text-sm font-semibold text-gray-900">{getCategoryName(categoria, t)}</h2>
                <span className="text-xs text-gray-400 tabular-nums">{tarefasCategoria.length}</span>
              </div>
              {tarefasCategoria.length === 0 ? (
                <p className="text-sm text-gray-400 pl-10">{t('tasks.emptyCategory')}</p>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                  {tarefasCategoria.map(tarefa => (
                    <Card key={tarefa.id} className="p-4 flex items-start gap-3">
                      <div className="flex-1 min-w-0">
                        <div className="font-medium text-gray-900 truncate">{tarefa.nome}</div>
                        <Badge tone="purple" className="mt-2">{t('tasks.weight', { weight: tarefa.peso })}</Badge>
                      </div>
                      <div className="flex items-center -mr-2 -mt-1">
                        <IconButton icon={Edit2} label={t('common.edit')} onClick={() => onEdit(tarefa)} />
                        <IconButton icon={Trash2} label={t('common.delete')} tone="danger" onClick={() => onDelete(tarefa)} />
                      </div>
                    </Card>
                  ))}
                </div>
              )}
            </section>
          );
        })}
      </div>
    </div>
  );
}
